export function clientReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_CLIENT":            
        case "UPDATE_CLIENT":            
            return {
                ...state,
                [payload.id]: payload
            }
        case "GET_CLIENTS":
            
            return payload;
        case "GET_RESUME_CLIENTS":
            
            return payload;
        
        default:
            return state;
    }
    
}